var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "font-semibold text-2xl" }, [
        _vm._v("\n            £" + _vm._s(_vm.price) + "\n        "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.options, function (option, index) {
        return !_vm.shouldBeHidden(option)
          ? _c("product-option", {
              key: option.id,
              staticClass: "mt-4",
              attrs: { option: option },
              model: {
                value: _vm.form.options[index],
                callback: function ($$v) {
                  _vm.$set(_vm.form.options, index, $$v)
                },
                expression: "form.options[index]",
              },
            })
          : _vm._e()
      }),
      _vm._v(" "),
      _c("form-quantity", {
        staticClass: "mt-4 max-w-xxxxs",
        attrs: { label: "Quantity", bold: true },
        model: {
          value: _vm.form.quantity,
          callback: function ($$v) {
            _vm.$set(_vm.form, "quantity", $$v)
          },
          expression: "form.quantity",
        },
      }),
      _vm._v(" "),
      _c(
        "form-button",
        {
          staticClass: "mt-4",
          nativeOn: {
            click: function ($event) {
              return _vm.addToBasket.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n            Add to Basket\n        ")]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }